import { useMemo, forwardRef } from "react";
import { string, object } from "prop-types";
import { observer } from "mobx-react"
import {
  useEstimateStructure,
  useEstimateEditorSettings,
  HeaderRow,
  useEstimateTableSettings,
} from "@tools";
import { ColumnFactory } from "./ColumnFactory";
import { ExpandContainer } from "@tools/EstimateEditor/components/Tables/cells/PinnableCell/components";

export const TableHeader = observer(forwardRef(({
  section,
  tableIdentifier,
}, ref) => {
  
  const { blockExpansions } = useEstimateEditorSettings();
  const { useExpandCell } = useEstimateTableSettings();
  const structure = useEstimateStructure();
  
  const { estimateViewLevel } = structure;
  const { allChildrenExpanded, isOpened } = section;

  const expanded = useMemo(() => (
    isOpened && allChildrenExpanded
  ), [allChildrenExpanded, isOpened]);

  const expandAllChildren = () => section.expandAllChildren(!expanded);
  
  return (
    <HeaderRow
      ref={ref}
      id={ tableIdentifier }
      // useExpandCell={ useExpandCell }
      // expandable={ !blockExpansions && estimateViewLevel > 1 }
      // expanded={ expanded }
      // onExpand={ expandAllChildren }
      // actionPresetClass="preset-tableBreakdownHeader"
      altBackground
      className="tableHeaderContainer"
      actionPresetClass="preset-page"
    >
      <ColumnFactory section={section}>
        {
          useExpandCell &&
          <ExpandContainer
            isHeader
            presetClassName="preset-tableBreakdownHeader"
            expandable={!blockExpansions && estimateViewLevel > 1}
            expanded={expanded}
            onExpand={expandAllChildren}
          />
        }
      </ColumnFactory>
    </HeaderRow>
  );
}));

TableHeader.propTypes = {
  section: object.isRequired,
  tableIdentifier: string.isRequired,
};
